const Menu = {
  queryList: [
    {
      name: 'name',
      label: '菜单名',
      component: 'input'
    },
    {
      name: 'url',
      label: 'name',
      component: 'input'
    },
    {
      name: 'type',
      label: '菜单级别',
      component: 'select',
      componentAttr: {
        options: [{
          value: 0,
          label: '一级目录'
        }, {
          value: 1,
          label: '二级目录'
        }, {
          value: 2,
          label: '按钮'
        }]
      }
    }
  ],
  urlMap: {
    'select': '/sys/menu/list',
    'delete': '/sys/menu/delete/{menuId}'
  },
  operList: [// 操作列表
    {
      name: 'add',
      label: '新增',
      show: true,
      action: {
        type: 'dialog',
        addr: 'systemManage/menuEdit'
      }
    }
  ],
  titles: [
    {
      name: 'name',
      label: '菜单名'
    },
    {
      name: 'url',
      label: 'name'
    },
    {
      name: 'icon',
      label: '图标标签',
      type: 'icon'
    },
    {
      name: 'type',
      label: '菜单级别',
      map: {
        0: '一级目录',
        1: '二级目录',
        2: '按钮'
      }
    },
    {
      name: 'parentName',
      label: '上级菜单'
    },
    {
      name: 'operation',
      label: '操作',
      actionList: [
        {
          label: '修改',
          kind: 'primary',
          type: 'dialog',
          addr: 'systemManage/menuEdit?{menuId}'
        },
        {
          label: '删除',
          kind: 'primary',
          type: 'request',
          addr: 'delete',
          confirm: {
            desc: '确认删除？'
          }
        }
      ]
    }
  ]
}
export default Menu



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/systemManage/menu.js